import * as posActions from "./posActions";
import * as posModels from "./api/posModels";
import AsyncInterval from "./AsyncInterval";
import describeNetworkError from "./describeNetworkError";
import logger from "./sentryLogger";
import {useState, useEffect, useRef} from "react";
import {useAppDispatch} from "./hooks";

const REFRESH_DELAY = 15000;

export default function useRefreshOrders(
    orderStatuses: posModels.OrderStatus[] = [],
    orderSources: posModels.OrderSource[] = [],
    training = false,
    refreshDelayMS = REFRESH_DELAY,
) {
    const dispatch = useAppDispatch();
    const [initialLoading, setInitialLoading] = useState(false);
    const [initialErrorMessage, setInitialErrorMessage] = useState("");

    const firstExecution = useRef(true);

    useEffect(() => {
        function refreshOrders() {
            return dispatch(
                posActions.getOrders(orderStatuses, orderSources, training),
            )
                .catch((err) => {
                    const description = describeNetworkError(err).join("\n");
                    logger.error("Failed to get historical orders.", {
                        errorMessage: description,
                    });

                    if (firstExecution.current) {
                        setInitialErrorMessage(description);
                    }
                })
                .finally(() => {
                    if (firstExecution.current) {
                        setInitialLoading(false);
                        firstExecution.current = false;
                    }
                });
        }

        const interval = new AsyncInterval(refreshOrders, refreshDelayMS);

        return () => {
            interval.cancel();
        };
    }, []);

    function closeInitialErrorMessage() {
        setInitialErrorMessage("");
    }

    return {initialLoading, initialErrorMessage, closeInitialErrorMessage};
}
